import styled from "styled-components";

export const FormWrapper = styled.div.attrs({
  className: " min-h-96",
})``;

export const FormHeaderText = styled.h1.attrs({
  className: "mb-2 text-4xl",
})`
  color: var(--black);
  font-weight: bolder;
  @media screen and (max-width: 1000px) {
    text-align: center;
  }
`;

export const Button = styled.button.attrs({
  className: "rounded w-full border-none h-16 mt-4",
})`
  background-color: var(--deepPurple);
  color: var(--white);
  cursor: pointer;
  transition: all 0.3s ease-in-out;

  &:disabled {
    opacity: 0.5;
  }
`;

export const FormSubTitle = styled.div.attrs({
  className: "mb-14",
})`
  color: var(--primaryPurple);
  font-size: 15px;

  @media screen and (max-width: 1000px) {
    font-size: 14px;
    text-align: center;
  }
`;

export const TextLight = styled.span.attrs({})`
  color: var(--primaryPurple);
`;

export const Success = styled.div.attrs({})`
  color: var(--primaryPurple);
  min-height: 100vh;
  display: flex;
  align-items: center;
  background-color: #3d0052;
  justify-content: center;

  @media screen and (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
`;
export const EmailLogo = styled.img.attrs({
  className: "",
})`
  height: 7rem;
  width: 7rem;
  margin: auto;
`;

export const CloseLogo = styled.img.attrs({
  className: "",
})`
  height: 4rem;
  width: 4rem;
  position: absolute;
  margin: 2rem;
  cursor: pointer;
`;

export const EmailContent = styled.div.attrs({
  className: "text-center",
})`
  max-width: 400px;
  color: white;
`;

export const SuccessButton = styled.button.attrs({
  className: "rounded mt-14 py-3 font-bold text-medium",
})`
  background-color: white;
  width: 100%;
  color: #3d0052;
  border: none;
`;
